import axios from "@/plugins/axios";

let url = "/api/console/shop/delivery/categories";

export default {
    gets(data){
        return axios.get(url, data).then(result => result.data);
    },
    get(data){
        return axios.get(`${url}/${data._id}`).then(result => result.data);
    },
    post(data){
        return axios.post(url, data).then(result => result.data);
    },
    put(data){
        return axios.put(`${url}/${data._id}`, data).then(result => result.data);
    },
    delete(data){
        return axios.delete(`${url}/${data._id}`).then(result => result.data);
    },

    postIcon(data, icon){
        var formData = new FormData(); formData.append("icon", icon);
        var headers = { "Content-Type": "multipart/form-data" };
        return axios.post(`${url}/${data._id}/icon`, formData, { headers }).then(result => result.data);
    },
    postIcon2(data, icon){
        var formData = new FormData(); formData.append("icon2", icon);
        var headers = { "Content-Type": "multipart/form-data" };
        return axios.post(`${url}/${data._id}/icon2`, formData, { headers }).then(result => result.data);
    },
}
